export enum SubscriptionTypes {
    FREE = 'Free',
    INDIVIDUAL = 'Individual',
    OFFICE = 'Office',
    FREE_TRIAL_INDIVIDUAL = 'FreeTrialIndividual',
    FREE_TRIAL_OFFICE = 'FreeTrialOffice',
}
